<div class="main-container" *ngIf="!isLoading && dockData" [ngStyle]="{ 'background-color': bgColor}">
  <h1 class="description" [ngStyle]="{'color': activeDock ? '#FFF' : '#000'}">{{dockData.description}}</h1>
  <app-takt [takt]="takt" [bgColor]="bgColor" [ngStyle]="{'color': activeDock ? '#FFF' : '#000'}"></app-takt>
  <div *ngIf=" !isLoading && tripDBData?.idFisco" class="boxes">
    <div class="arrival-group">
      <div class="arrival-box" [ngStyle]="{'background-color': getArrivalColor()}">Chegada {{definedArrival}}</div>
      <div class="arrival-box" [ngStyle]="{'background-color': getArrivalColor()}">
        Chegada real {{dockData.status | date: 'HH:mm:ss'}}
      </div>
    </div>
    <div class="info-group">
      <div class="info-box">Placa {{plate}}</div>
      <div class="info-box">{{company}}</div>
    </div>
    <div class="departure-group">
      <div class="departure-box" [ngStyle]="{'background-color': getDepartureColor()}">Saída {{definedDeparture}}</div>
      <div class="departure-box" [ngStyle]="{'background-color': getDepartureColor()}">Saída real
        {{remainingRealTimeFormatted}}</div>
    </div>
  </div>
  <button *ngIf="!tripDBData?.idFisco && activeDock && !isLoading && !isViewOnly" (click)="visibilityClick()">Inserir viagem</button>
</div>

<div class="loading-container" *ngIf="isLoading">
  <div class="spinner"></div>
  <p>Carregando dados...</p>
</div>

  <div *ngIf="showIntegrationForm" class="overlay" (click)="toggleIntegrationForm()">
    <app-packing-integration-form [dockIdReceived]="dockId" >
    </app-packing-integration-form>
  </div>